module.exports = __webpack_public_path__ + "e4cb72292d548029f81b0213b798058f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/location.svg
// module id = 241
// module chunks = 0